import './bml-contact-banner.scss';
const TEMPLATE = `
<section class="contact-banner fade-up">
    <div class="contact-circles-wrapper" data-animate-circles>
        <div class="contact-circle contact-circle-extra-large"></div>
        <div class="contact-circle contact-circle-large"></div>
        <div class="contact-circle contact-circle-medium"></div>
    </div>
    <div class="special-container d-flex justify-content-center d-md-none">
        <span data-animate-child class="image-placeholder d-md-none"></span>
    </div>
    <h1 data-animate-child>Будуємо<br> довіру, <span data-animate-child
                                                     class="image-placeholder d-none d-md-inline-block"></span>
        зміцнюємо </h1>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">

            </div>
            <div class="col-md-6">
                <h1 style="margin-bottom: 10px; padding-left: 0" data-animate-child>партнерство</h1>
                <p data-animate-child>Ми цінуємо партнерство й гарантуємо швидкий зворотний контакт. Залиште заявку
                    — і ми надамо рішення для ваших потреб.</p>
            </div>
        </div>
    </div>

</section>
`;

class BmlContactBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-contact-banner', BmlContactBanner);
